import React, { Component } from 'react'
import Table from 'antd/lib/table';
import PropTypes from 'prop-types';
import { TweenOneGroup } from 'rc-tween-one';
import lodash from 'lodash';

const TableContext = React.createContext(false);

class AnimatedTable extends Component {

    static propTypes = {
        className: PropTypes.string,
    };

    static defaultProps = {
        className: 'table-enter-leave-demo',
    };
    constructor(props) {
        super(props)

        this.enterAnim = [
            {
                opacity: 0, x: 30, backgroundColor: '#fffeee', duration: 0,
            },
            {
                height: 0,
                duration: 200,
                type: 'from',
                delay: 250,
                ease: 'easeOutQuad',
                onComplete: this.onEnd,
            },
            {
                opacity: 1, x: 0, duration: 250, ease: 'easeOutQuad',
            },
            { delay: 100, backgroundColor: 'transparent' },
        ];
        this.pageEnterAnim = [
            {
                opacity: 0, duration: 0,
            },
            {
                height: 0,
                duration: 150,
                type: 'from',
                delay: 150,
                ease: 'easeOutQuad',
                onComplete: this.onEnd,
            },
            {
                opacity: 1, duration: 150, ease: 'easeOutQuad',
            },
        ];
        this.leaveAnim = [
            { duration: 250, opacity: 0 },
            { height: 0, duration: 200, ease: 'easeOutQuad' },
        ];
        this.pageLeaveAnim = [
            { duration: 150, opacity: 0 },
            { height: 0, duration: 150, ease: 'easeOutQuad' },
        ];

        this.animTag = ($props) => {
            return (
                <TableContext.Consumer>
                    {(isPageTween) => {
                        return (
                            <TweenOneGroup
                                component="tbody"
                                enter={!isPageTween ? this.enterAnim : this.pageEnterAnim}
                                leave={!isPageTween ? this.leaveAnim : this.pageLeaveAnim}
                                appear={false}
                                exclusive
                                {...$props}
                            />
                        );
                    }}
                </TableContext.Consumer>
            );
        };

        this.state = {
            isPageTween: false,
        }
    }

    onEnd = (e) => {
        const dom = e.target;
        dom.style.height = 'auto';
    }
    pageChange = () => {
        this.setState({
            isPageTween: true,
        });
    };

    triggerDataChange = () => {
        console.log("data change triggered")
        this.setState({
            isPageTween: false,
        });
    }

    render() {
        return (
            <TableContext.Provider value={this.state.isPageTween}>
                <Table
                    showHeader={this.props.showHeader}
                    loading={this.props.loading}
                    className={`${this.props.className} table-enter-leave-demo-table`}
                    columns={this.props.columns || []}
                    pagination={this.props.pagination}
                    dataSource={this.props.dataSource}
                    rowKey={(record, index) => `${record.id}-`}
                    //   className={`${this.props.className}-table`}
                    components={{ body: { wrapper: this.animTag } }}
                    onChange={this.pageChange}
                    locale={this.props.locale}
                />
            </TableContext.Provider>
        )
    }

    componentWillReceiveProps(nextProps) {
        let old_data = this.props.dataSource || [];
        let new_data = nextProps.dataSource || []
        // if (!lodash.isEqual(old_data, new_data)) {
        //     console.log("data changed")
        //     this.setState({
        //         isPageTween: false,
        //     })
        // }
    }

    componentDidMount() {
        typeof this.props.onRef == 'function' && this.props.onRef(this);
    }
    componentWillUnmount() {
        typeof this.props.onRef == 'function' && this.props.onRef(null);
    }
}

export default AnimatedTable
